<div class="comments-page">
  <!-- Gradient ellipses for mobile view -->
  <div class="gradient-ellipse-1"></div>
  <div class="gradient-ellipse-2"></div>
  <div class="gradient-ellipse-3"></div>

  <nav class="comments-navbar">
    <button class="chev" type="button" (click)="goBack()" aria-label="Back">
      <img src="/assets/images/Expand_Chevron.png" class="rot90" alt="Back">
    </button>
    <div class="nav-title">Comments Notifications</div>
  </nav>

  <section class="notif-section">
    <div class="notif-bg">
      <h1 class="desktop-panel-title">Comments Notifications</h1>
      <div class="notif-caption">Comments from the last 24hrs</div>

      <div *ngIf="isLoading(); else listTpl" class="loading">Loading…</div>
      <ng-template #listTpl>
        <div *ngIf="items().length; else emptyTpl" class="notif-list">
          <button class="notif-card" *ngFor="let n of items()" (click)="openNotification(n)" (keydown.enter)="openNotification(n)" (keydown.space)="openNotification(n)" type="button">
            <div class="notif-row">
              <div class="avatar">{{ initials(n.commenterName) }}</div>
              <div class="notif-content">
                <div class="notif-title">
                  <span class="name">{{ n.commenterName }}</span>
                  <span class="mid"> commented on </span>
                  <span class="load">Load {{ n.loadNumber }}</span>
                </div>
                <div class="notif-body">
                  <span class="bar"></span>
                  <span class="text">{{ n.message }}</span>
                </div>
                <div class="notif-time">{{ formatAgo(n.createdAt) }}</div>
              </div>
            </div>
          </button>
        </div>
        <ng-template #emptyTpl>
          <div class="empty-notif">
            <div class="empty-circle">
              <img class="empty-icon" src="/assets/images/No_Notifications.png" alt="No notifications">
            </div>
            <div class="empty-title">No Notifications Yet</div>
          </div>
        </ng-template>
      </ng-template>
    </div>
  </section>

  <app-navbar [items]="[
    { id: 'profile', label: 'Profile', selectedIcon: '/assets/images/Person_Selected.png', unselectedIcon: '/assets/images/Person_Unselected.png' },
    { id: 'home', label: 'Homepage', selectedIcon: '/assets/images/Home_Selected.png', unselectedIcon: '/assets/images/Home_Unselected.png' },
    { id: 'contacts', label: 'Contacts', selectedIcon: '/assets/images/Contact_Selected.png', unselectedIcon: '/assets/images/Contact_Unselected.png' }
  ]" [selectedId]="null" (selectedIdChange)="router.navigate([ $event === 'home' ? '/growers' : '/' + $event ])"></app-navbar>
</div>


